import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { localStorageHelper } from 'src/services';
import { typeConfigDoc } from '@monorepo/models';
import { unauthenticatedConfig } from '@monorepo/helpers';

const configLocalStorage = localStorageHelper.GetConfig ? localStorageHelper.GetConfig() : alert("No se cargó Config LS Service");

const configurationSlice = createSlice({
    name: 'configuration',
    initialState: configLocalStorage ?? unauthenticatedConfig,
    reducers: {
        setConfigurationReducer: (state, action: PayloadAction<typeConfigDoc>) => {
            if (Number.isInteger(action.payload.numberOfTerritories)) {
                state = action.payload;
                localStorageHelper.SetConfig(action.payload);
            }
            return state;
        }
    }
});

export const configurationReducer = configurationSlice.reducer;

export const { setConfigurationReducer } = configurationSlice.actions;
